export const borderRadius = {
  squared: 0,
  rounded: 12,
  circular: 999
}
